import { render, staticRenderFns } from "./CommonLayout.vue?vue&type=template&id=5e99e0ea&"
import script from "./CommonLayout.vue?vue&type=script&lang=js&"
export * from "./CommonLayout.vue?vue&type=script&lang=js&"
import style0 from "./CommonLayout.vue?vue&type=style&index=0&id=5e99e0ea&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports